const MULTIPLIER = 30.48;

export const feetToCm = (feet: number) => feet * MULTIPLIER;

export const cmToFeet = (cm: number) => cm / MULTIPLIER;
